<div (click)="openUploadReportItemModal(orderDetailsObj)">{{msg}}</div>